import Vue from 'vue';

const message = {

    namespaced: true,
    state: {
        data: {
            message: null,
            code: null,
            title: null,
            type: null
        }

    },


    getters: {
        getMessage: state => state.data
    },

    actions: {

        actionSetMessage({ commit }, { message, code, title, type }) {
            commit("setMessage", { message, code, title, type });
        },
        actionResetMessage({ commit }) {
            commit("resetMessage");
        },
        actionSetMessageStrOnly({ commit }, message) {
            commit("setMessage", { message });
        },
        actionConfirmMessage({ commit, state }, message) {

            return new Promise((resolve, reject) => {
                //show msg
                commit("setMessage", { code: 3, message });
                //return if confirm
                $('#confirmModalBtn').click(() => {
                    resolve(true);
                })
                $('#confirmModal').on('hidden.bs.modal', function (e) {
                    reject("close")
                })
            })
        }


    },
    // mutations
    mutations: {
        setMessage(state, { message, code, title, type }) {
            Vue.set(state, "data", { message, code, title, type })
        },
        resetMessage(state) {
            state.data.message = null;
            state.data.code = null;
            state.data.title = null;
        }
    }
}



export default message